import { cn } from '~utils/cn'

import Icon from '~components/ui/icon'

type AttachmentProps = Readonly<
  React.ImgHTMLAttributes<HTMLImageElement> & {
    onDelete?: () => void
    isVideo?: boolean
  }
>

const Attachment = ({
  src,
  width = 96,
  height = 96,
  isVideo = false,
  onDelete,
  ...props
}: AttachmentProps) => {
  return (
    <div
      className="relative overflow-hidden rounded-lg border border-solid border-gray-300 bg-gray-300 dark:border-gray-700"
      style={{
        width,
        height,
      }}
    >
      <button
        aria-label="delete-button"
        className="absolute right-1 top-1 z-10 size-5 rounded-full bg-gray-700"
        onClick={onDelete}
      >
        <Icon name="remove_circle_solid" />
      </button>
      {isVideo && (
        <div className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2">
          <img
            src={`${import.meta.env.VITE_STATIC_RES}/icn/icnVideoPlayerNormalWhite28.svg`}
            alt="play-icon"
            width={28}
            height={28}
          />
        </div>
      )}
      <img
        {...props}
        alt="attachment"
        src={src}
        className={cn(isVideo && 'brightness-[60%]', !width && 'size-24')}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
    </div>
  )
}

export default Attachment
